import { Link } from 'react-router-dom';
import { footerColumns } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-white">
      <div className="px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-white mb-4 pb-3 border-b border-white/15">
                {col.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-white/55 hover:text-white/85 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 md:mt-24 flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
          <div>
            <div className="flex items-baseline gap-2 mb-3">
              <span className="text-4xl md:text-5xl font-bold font-heading text-white">吃瓜</span>
              <span className="text-2xl md:text-3xl font-light text-white/40">网站线路一</span>
            </div>
            <div className="w-8 h-px bg-white/20 mb-3"></div>
            <p className="text-xs text-white/35 max-w-xs leading-relaxed">
              聚合51吃瓜网站入口与51吃瓜在线观看等热门通道，每日更新网红塌房黑料，一站式直达最新大瓜现场
            </p>
          </div>

          <div className="flex flex-col items-start md:items-end gap-3">
            <div className="flex items-center gap-4">
              <a
                href="http://kp51.cn/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white/60 hover:bg-white/20 hover:text-white transition-colors cursor-pointer"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a
                href="http://kp51.cn/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white/60 hover:bg-white/20 hover:text-white transition-colors cursor-pointer"
                aria-label="微信"
              >
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a
                href="http://kp51.cn/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white/60 hover:bg-white/20 hover:text-white transition-colors cursor-pointer"
                aria-label="抖音"
              >
                <i className="ri-tiktok-line text-base"></i>
              </a>
            </div>
            <p className="text-xs text-white/25">
              &copy; {new Date().getFullYear()} 吃瓜网站线路一 版权所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}